export const GET_RECEIPT_PENDING = "GET_RECEIPT_PENDING"
export const GET_RECEIPT_SUCCESS = "GET_RECEIPT_SUCCESS"
export const GET_RECEIPT_FAILURE = "GET_RECEIPT_FAILURE"

export const ADD_RECEIPT_PENDING = "ADD_RECEIPT_PENDING"
export const ADD_RECEIPT_SUCCESS = "ADD_RECEIPT_SUCCESS"
export const ADD_RECEIPT_FAILURE = "ADD_RECEIPT_FAILURE"

export const UPLOAD_RECEIPT_PENDING = "UPLOAD_RECEIPT_PENDING"
export const UPLOAD_RECEIPT_SUCCESS = "UPLOAD_RECEIPT_SUCCESS"
export const UPLOAD_RECEIPT_FAILURE = "UPLOAD_RECEIPT_FAILURE"

export const EDIT_RECEIPT_PENDING = "EDIT_RECEIPT_PENDING"
export const EDIT_RECEIPT_SUCCESS = "EDIT_RECEIPT_SUCCESS"
export const EDIT_RECEIPT_FAILURE = "EDIT_RECEIPT_FAILURE"

export const DELETE_RECEIPT_PENDING = "DELETE_RECEIPT_PENDING"
export const DELETE_RECEIPT_SUCCESS = "DELETE_RECEIPT_SUCCESS"
export const DELETE_RECEIPT_FAILURE = "DELETE_RECEIPT_FAILURE"

export const DOWNLOAD_RECEIPT_PENDING = "DOWNLOAD_RECEIPT_PENDING"
export const DOWNLOAD_RECEIPT_SUCCESS = "DOWNLOAD_RECEIPT_SUCCESS"
export const DOWNLOAD_RECEIPT_FAILURE = "DOWNLOAD_RECEIPT_FAILURE"
